let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1Jok2"), load("7KgfJ"), load("c6MKV"), load("5TCys")]).then(() => parcelRequire('1wIcl'));